import { render, staticRenderFns } from "./MessageContentCarousel.vue?vue&type=template&id=c61cf448&scoped=true&"
import script from "./MessageContentCarousel.vue?vue&type=script&lang=js&"
export * from "./MessageContentCarousel.vue?vue&type=script&lang=js&"
import style0 from "../../style/message-box.scss?vue&type=style&index=0&id=c61cf448&lang=scss&scoped=true&"
import style1 from "./MessageContentCarousel.vue?vue&type=style&index=1&id=c61cf448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61cf448",
  null
  
)

export default component.exports